import { ReactNode } from 'react';
import { TopNav } from './TopNav';
import { Sidebar } from './Sidebar';
import SessionTimeoutModal from '../../components/authorization/SessionTimeoutModal/SessionTimeoutModal';
import { useAuthorization } from '../../utils/hooks';
import EnvironmentBanner from '../../components/ui/EnvironmentBanner/EnvironmentBanner';

interface IDefaultLayout {
  children: ReactNode;
}

export const DefaultLayout = ({ children }: IDefaultLayout) => {
  const auth = useAuthorization();
  return (
    <>
      <a className="sr-only" href="#mainContent">
        Skip to main content
      </a>
      <EnvironmentBanner />
      <div className="d-flex" id="wrapper">
        <Sidebar sidebarMenu={auth.sidebarMenu} />
        <div id="page-content-wrapper">
          <TopNav logout={auth.logout} profileMenu={auth.profileMenu} />
          <SessionTimeoutModal logout={auth.logout} />
          <div id="mainContent">
            <div className="container-fluid">{children}</div>
          </div>
        </div>
      </div>
    </>
  );
};
